import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

/**
 * One entry per component in `components/Icons/`. They share a map rather than
 * a file each because an icon has exactly one element to address, and the set
 * grows every time a page needs a new glyph.
 */
export const iconComponent = {
  checkBox: 'icon.check-box',
  checkBoxOutlineBlank: 'icon.check-box-outline-blank',
  checkCircle: 'icon.check-circle',
  checkCircleRounded: 'icon.check-circle-rounded',
  checked: 'icon.checked',
  closeRounded: 'icon.close-rounded',
  driveFolderUploadOutlined: 'icon.drive-folder-upload-outlined',
  exitToAppOutlined: 'icon.exit-to-app-outlined',
  expandMoreRounded: 'icon.expand-more-rounded',
  homeOutlined: 'icon.home-outlined',
  infoRounded: 'icon.info-rounded',
  keyboardBackspaceRounded: 'icon.keyboard-backspace-rounded',
  menuRounded: 'icon.menu-rounded',
  navigateNextRounded: 'icon.navigate-next-rounded',
  pictureAsPdf: 'icon.picture-as-pdf',
  unchecked: 'icon.unchecked',
  uploadFileRounded: 'icon.upload-file-rounded',
} as const satisfies ComponentLocatorMap;
